module.exports = __webpack_public_path__ + "img/accounts-active.1b489873.svg";